import {
  DirectBudgetActions,
  DirectBudgetHeader,
  DirectBudgetLine,
  DirectBudgetWorkbenchModel,
  LookupItem,
} from './directbudget.models';

const n = (v: any, d = 0) => (Number.isFinite(Number(v)) ? Number(v) : d);

const s = (v: any, d = '') => (v == null ? d : String(v));

const b = (v: any) =>
  v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true';

export const normalizeLine = (r: any): DirectBudgetLine => {
  const lineid = n(r?.lineid ?? r?.rid);
  return {
    id: lineid,
    lineid,
    lineix: s(r?.lineix ?? r?.rix),
    headerid: n(r?.headerid),
    costcenterid: n(r?.costcenterid),
    costcentercode: s(r?.costcentercode),
    costcentername: s(r?.costcentername),
    accountid: n(r?.accountid),
    accountcode: s(r?.accountcode),
    accountname: s(r?.accountname),
    linename: s(r?.linename),
    linecode: s(r?.linecode),
    description: s(r?.description),
    quantity: n(r?.quantity, 1),
    unitprice: n(r?.unitprice),
    requestedamount: n(r?.requestedamount),
    approvedamount: n(r?.approvedamount),
    justification: s(r?.justification),
    remarks: s(r?.remarks),
    stamp: s(r?.stamp),
    status: n(r?.status, 1),
    _state: 'clean',
    __dirty: false,
    __error: '',
  };
};

export const normalizeWorkbench = (raw: any): DirectBudgetWorkbenchModel => {
  const x = raw?.sd ?? raw ?? {},
    c = x.context ?? {},
    a = x.actions ?? {},
    h = x.header;

  const actions: DirectBudgetActions = {
    canRefresh: b(a.canRefresh),
    canCreate: b(a.canCreate),
    canEdit: b(a.canEdit),
    canSave: b(a.canSave),
    canValidate: b(a.canValidate),
    canSubmit: b(a.canSubmit),
    canReopen: b(a.canReopen),
    canComplete: b(a.canComplete),
    canExit: b(a.canExit),
    nextpage: a.nextpage == null ? null : s(a.nextpage),
  };

  const header: DirectBudgetHeader | null = h
    ? {
        headerid: n(h.headerid),
        headerix: s(h.headerix),
        planningcycleid: n(h.planningcycleid),
        budgetcontrolid: n(h.budgetcontrolid),
        versionno: n(h.versionno),
        stateid: n(h.stateid),
        statecode: s(h.statecode),
        statename: s(h.statename),
        headername: s(h.headername),
        headercode: s(h.headercode),
        linecount: n(h.linecount),
        requestedamount: n(h.requestedamount),
        approvedamount: n(h.approvedamount),
        ceilingamount: n(h.ceilingamount),
        availableamount: n(h.availableamount),
        utilisationpercent: n(h.utilisationpercent),
        controlstatus: s(h.controlstatus),
        stamp: s(h.stamp),
      }
    : null;

  const look = (r: any): LookupItem => ({
    id: n(r?.id),
    code: s(r?.code),
    name: s(r?.name),
  });
  
  return {
    context: {
      planningcycleid: n(c.planningcycleid),
      planningcycleix: s(c.planningcycleix),
      planningcyclecode: s(c.planningcyclecode),
      planningcyclename: s(c.planningcyclename),
      budgetperiodid: n(c.budgetperiodid),
      budgetperiodcode: s(c.budgetperiodcode),
      budgetperiodname: s(c.budgetperiodname),
      fiscalyear: s(c.fiscalyear),
      phasecode: s(c.phasecode),
    },
    dashboard: {
      visible: x.dashboard?.visible !== false,
      title: x.dashboard?.title ?? null,
      cards: Array.isArray(x.dashboard?.cards) ? x.dashboard.cards : [],
    },
    header,
    lines: Array.isArray(x.lines) ? x.lines.map(normalizeLine) : [],
    costcenters: Array.isArray(x.costcenters) ? x.costcenters.map(look) : [],
    accounts: Array.isArray(x.accounts) ? x.accounts.map(look) : [],
    actions,
  };
};
